import React, { ReactElement, useState, VFC } from 'react';
import { AddressData } from 'react-daum-postcode';
import Button, { ButtonProps } from '../Button';
import ModalPostcode from '../ModalPostcode';

interface AddressButtonProps extends Omit<ButtonProps, 'onClick'> {
  onSelectAddress?: (address: AddressData) => void;
  renderButton?: (props: { onClick: () => void }) => ReactElement;
}

const AddressButton: VFC<AddressButtonProps> = ({
  onSelectAddress: onSelect,
  renderButton,
  ...props
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const open = () => setModalOpen(true);
  const close = () => setModalOpen(false);

  const onSelectAddress = (data: AddressData) => {
    onSelect?.(data);
    setModalOpen(false);
  };

  const buttonProps = { onClick: open };

  return (
    <>
      {renderButton ? (
        renderButton(buttonProps)
      ) : (
        <Button
          type="button"
          full
          color="blue"
          outline
          {...props}
          onClick={open}
        >
          주소검색
        </Button>
      )}
      {modalOpen && (
        <ModalPostcode
          isOpen
          dismissable
          onSelectAddress={onSelectAddress}
          onRequestClose={close}
        />
      )}
    </>
  );
};
export default AddressButton;
